
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mao-na-roda",
      function () {
        return require("private-next-pages/mao-na-roda.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mao-na-roda"])
      });
    }
  